import React from 'react';
import { useMutation } from '@apollo/client';
import TrackerEditMealMutation from './TrackerEditMealMutation';
import TrackerQuery from '../Fetch/TrackerQuery';
import { formatIsoDate } from '../../../Helpers/dateFormatter';
import FetchMealQuery from '../FetchMeal/FetchMealQuery';

interface ITrackerEditMealConnectorApolloProps {
  children: ({ editMeal }: { editMeal: (input: any) => Promise<any> }) => React.ReactElement;
  post: any;
  originalDate: string;
}

const TrackerEditMealConnectorApollo: React.FC<ITrackerEditMealConnectorApolloProps> = ({
  children,
  post,
  originalDate,
}) => {
  const [editMealMutation] = useMutation(TrackerEditMealMutation);

  const editMeal = async (input: any) => {
    const refetchQueriesArray: any[] = [];
    if (input.dateTime) {
      const date = formatIsoDate(new Date(input.dateTime));

      refetchQueriesArray.push({
        query: TrackerQuery,
        variables: {
          date,
        },
      });

      if (originalDate !== date) {
        refetchQueriesArray.push({
          query: TrackerQuery,
          variables: {
            date: originalDate,
          },
        });
      }
    } else {
      // update user meal
      refetchQueriesArray.push({
        query: FetchMealQuery,
        variables: {
          id: input.mealId,
        },
      });
    }

    const response = await editMealMutation({
      variables: { input },
      awaitRefetchQueries: true,
      refetchQueries: refetchQueriesArray,
    });

    if (post) {
      post('reload');
    }

    return response.data.dailyTracker.editMeal;
  };
  return children({ editMeal });
};

export default TrackerEditMealConnectorApollo;
